/*
  extendInfo.js-是vuex的一个module，用来存放当前项目所需要的额外信息
  by.qiushangzhe 2020-01-22
*/

const state = {
  vuexTeacherList: null, // 用户显示的名字
  vuexProducorLeader: null, // 审批人信息
  vuexOrganizationList: null, // 机构列表
  vuexSummaryInfo: null, // 类型和方向和专业信息
  vuexFitInfo: null // 适合专业的列表
}

const getters = {
  getTeacher (state) {
    return (id) => {
      if (state.vuexTeacherList && id) {
        const teacherInfo = state.vuexTeacherList.filter((item) => { return item.id * 1 === id * 1 })[0]
        if (teacherInfo) {
          return teacherInfo
        }
      } else {
        return []
      }
    }
  },
  getTeacherByIndex () {
    return (teacherIndex) => {
      if (teacherIndex) {
        const teacherInfo = state.vuexTeacherList.filter((item) => { return item.teacherIndex === teacherIndex })[0]
        if (teacherInfo) {
          return teacherInfo
        }
      }
    }
  }
}

const mutations = {
  SET_EXTEND_INFO (state, data) {
    if (data.teacherList) { state.vuexTeacherList = data.teacherList }
    if (data.producorLeader) { state.vuexProducorLeader = data.producorLeader }
    if (data.summaryInfo) { state.vuexSummaryInfo = data.summaryInfo }
    if (data.organizationList) { state.vuexOrganizationList = data.organizationList }
    if (data.fitList) { state.vuexFitInfo = data.fitList }
  }
}
const actions = {
  initExtendInfo (context, data) {
    context.commit('SET_EXTEND_INFO', data)
  }
}

export default { namespaced: true, state, getters, mutations, actions }
